import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { Alert } from '@mantine/core';
import type { ReactNode } from 'react';

import { Icon } from '../Spinner/Icon';
import type { AlertProps } from './AlertProps';

const AlertIcon = <Icon icon={faTriangleExclamation} />;

export function ErrorAlert({ icon: iconProp, title, children }: AlertProps): ReactNode {
	const icon = iconProp ?? AlertIcon;

	return (
		<Alert c={'red.9'} bg={'red.1'} variant="light" title={title} icon={icon}>
			{children}
		</Alert>
	);
}
